import React from "react";
import { useFocusable } from "../../../utils/Helpers";
export var SearchKeyboardKeyView = function (_a) {
    var focusRaw = _a.focusRaw, className = _a.className, keyText = _a.keyText, onKeyPressHandle = _a.onKeyPressHandle;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onKeyPressHandle(keyText); },
    });
    return (React.createElement("div", { key: keyText, ref: ref, tabIndex: 0, className: className }, keyText === "🌐" ? React.createElement("div", { className: "globe-icon" }) : keyText));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/search/SearchKeyboardKeyView.tsx
// module id = 167
// module chunks = 1